<template>
	<div>
		<van-nav-bar title="群中心" left-text="返回" left-arrow fixed placeholder @click-left="goBack" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<div class="top">
			<div class="t-avatar" v-if="group_info.headimgurl">
				<img :src="group_info.headimgurl">
			</div>
			<div class="t-info" v-if="group_info.nickname">
				<div class="nickname">{{group_info.nickname}}</div>
				<div v-if="group_info.is_expires" style="color: red;"><small>已到期</small></div>
			</div>
		</div>
		<van-cell title="基础功能" />
		<van-grid :border="false" :clickable="true" :column-num="3">
			<van-grid-item icon="setting-o" to="/group-src-set" text="设置" />
			<van-grid-item icon="chat-o" to="/group-src-chat" text="智能聊天" />
			<van-grid-item icon="music-o" to="/group-src-music" text="智能点歌" />
			<van-grid-item icon="friends-o" to="/group-src-welcome" text="入群欢迎" />
			<van-grid-item icon="manager-o" to="/group-src-outmessage" text="退群提醒" />
			<van-grid-item icon="smile-o" to="/group-src-users" text="成员管理" />
			<van-grid-item icon="flower-o" to="/group-src-weather" text="天气播报" />
			<van-grid-item icon="like-o" to="/group-src-sign" text="签到" />
			<van-grid-item icon="other-pay" to="/group-src-calc" text="邀请统计" />
		</van-grid>

		<van-cell title="回复功能" />
		<van-grid :border="false" :clickable="true" :column-num="3">
			<van-grid-item icon="smile-comment-o" to="/group-src-text" text="文字" />
			<van-grid-item icon="photo-o" to="/group-src-image" text="图片" />
			<van-grid-item icon="idcard" to="/group-src-idcard" text="名片" />
			<van-grid-item icon="shrink" to="/group-src-link" text="分享链接" />
			<van-grid-item icon="desktop-o" to="/group-src-mini" text="小程序" />
			<van-grid-item icon="question-o" to="/group-src-invita" text="暗号进群" />
			<!-- <van-grid-item icon="tosend" to="" text="定时消息" /> -->
		</van-grid>

		<van-cell title="群管功能" />
		<van-grid :border="false" :clickable="true" :column-num="3">
			<van-grid-item icon="setting-o" to="/group-src-aset" text="设置" />
			<van-grid-item icon="aim" to="/group-src-aaite" text="艾特(@)踢人" />
			<van-grid-item icon="smile-comment-o" to="/group-src-akeyword" text="关键词" />
			<van-grid-item icon="idcard" to="/group-src-aidcard" text="名片" />
			<van-grid-item icon="shrink" to="/group-src-alink" text="分享链接" />
			<van-grid-item icon="desktop-o" to="/group-src-amini" text="小程序" />
		</van-grid>

		<van-cell title="娱乐功能" />
		<van-grid :border="false" :clickable="true" :column-num="3">
			<van-grid-item icon="gift-card-o" to="/group-src-ctp" text="猜图片" />
			<van-grid-item icon="circle" to="/group-src-cyjl" text="成语接龙" />
			<van-grid-item icon="medal-o" to="/group-src-cgm" text="猜歌名" />
			<van-grid-item icon="eye-o" to="/group-src-zc" text="找茬" />
			<van-grid-item icon="smile-comment-o" to="/group-src-cwzyx" text="猜王者英雄" />
			<van-grid-item icon="desktop-o" to="/group-src-njy" text="诺基亚" />
			<van-grid-item icon="cash-on-deliver" to="/group-src-dj" text="打劫" />
			<van-grid-item icon="gift-o" to="/group-src-lw" text="送礼物" />
			<van-grid-item icon="todo-list-o" to="" badge="免" text="我的2021" />
			<van-grid-item icon="balance-o" to="" badge="免" text="求财神" />
			<van-grid-item icon="star-o" to="" badge="免" text="查星座" />
		</van-grid>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Grid,
		GridItem,
		NavBar
	} from 'vant';

	Vue.use(Grid);
	Vue.use(GridItem);
	Vue.use(NavBar);
	export default {

		data() {
			return {
				group_id: 0,
				group_info: {}
			}
		},

		created() {
			var group_id = localStorage.getItem('select_id')
			if (!group_id) {
				this.$router.push('/member-center')
				return;
			}
			this.group_id = group_id
			this.$ApiUtil.GroupCenter.get({
				id: this.group_id
			}).then(res => {
				if (!res.status) {
					this.$dialog.alert({
						message: res.message
					}).then(() => {
						this.$router.push('/member-center')
					})
				}
				if(res.data.is_expires){
					this.$dialog.confirm({
						message: '该群到期了，服务已停用！\n是否立马去续费呢?',
						confirmButtonText: '好',
						cancelButtonText: '下次吧'
					}).then( () => {
						this.$router.push('/group-resur-' + group_id)
					} ).catch( () => {
						
					} )
				}
				this.group_info = res.data
				
			})
			
			
		},
		methods: {
			goBack() {
				// this.$router.push('/member-center')
				location.href = '/member-center'
			}
		}

	}
</script>

<style scoped>
	.van-icon__image {
		width: 1em;
		height: 1em;
	}

	.top {
		height: 8em;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding-left: 2em;
		background: url(../../assets/icon-1.png) center no-repeat;
		background-size: cover;
		font-family: "microsoft yahei";
		/* border-radius: 0.8em 0.8em 0 0; */
	}

	.top .t-avatar {
		margin-right: 1em;
	}

	.top .t-avatar img {
		width: 4em;
		height: 4em;
		border-radius: 4em;
		border: 2px solid #fff;
	}

	.top .t-info {
		font-size: 10px;
		color: #fff;
		font-weight: bold;
	}

	.top .t-info .nickname {
		font-size: 16px;
		font-weight: normal;
	}
</style>
